import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Printer, FileDown, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { downloadReceiptPdf } from "@/lib/receipt";
import { formatApiError } from "@/lib/api";

export function ReceiptActions({ invoiceId }) {
  const [busy, setBusy] = useState(false);

  async function pdf() {
    setBusy(true);
    try { await downloadReceiptPdf(invoiceId); }
    catch (e) { toast.error(formatApiError(e)); }
    finally { setBusy(false); }
  }

  return (
    <div className="flex gap-2 mt-4">
      <Button data-testid="receipt-print-btn" variant="outline" className="flex-1 border-violet-200 text-violet-700 hover:bg-violet-50"
        onClick={() => window.open(`/receipt/${invoiceId}`, "_blank")}>
        <Printer size={15} className="mr-1.5" /> Print receipt
      </Button>
      <Button data-testid="receipt-pdf-btn" onClick={pdf} disabled={busy} className="flex-1 bg-violet-600 hover:bg-violet-700">
        {busy ? <Loader2 size={15} className="animate-spin mr-1.5" /> : <FileDown size={15} className="mr-1.5" />} Download PDF
      </Button>
    </div>
  );
}
